import angular from 'angular';
import categoryFilters from './categoryFilters';

export default angular
  .module('components.categoryFilters', [])
  .component('categoryFilters', categoryFilters).name;
